export default __webpack_public_path__ + "static/media/island_1.db621be1.png";